import React from 'react';
const OptimizedImage = ({ src, alt, width, height, className = '', }) => {
    return (React.createElement("img", { src: src, alt: alt, width: width, height: height, className: className, loading: "lazy", decoding: "async" }));
};
export default OptimizedImage;
